// extracted by mini-css-extract-plugin
export default {"path":"XNyYH","slash":"CIrQ_","item":"ljnzZ","dots":"crW7e"};